import { render, staticRenderFns } from "./ShowGoods2.vue?vue&type=template&id=f74b2e0e&scoped=true&"
import script from "./ShowGoods2.vue?vue&type=script&lang=js&"
export * from "./ShowGoods2.vue?vue&type=script&lang=js&"
import style0 from "./ShowGoods2.vue?vue&type=style&index=0&id=f74b2e0e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74b2e0e",
  null
  
)

export default component.exports